'use strict';

function checkGenderHref(url) {
    var gender = new RegExp('[\\?&]gender=([^&#]*)').exec(url);
    if (!gender) return null;
    return gender[1];
};

let replaceOrAddQueryParam = (url, parameter, value) => {
    var regex = new RegExp(parameter + '=[^&]+');
    var split = url.split(regex);
    if (split.length > 1) {
        return split[0] + (url.indexOf('?') > -1 ? '' : '?') + parameter + '=' + value + split[1];
    } else {
        return url + (url.indexOf('?') > -1 ? '&' : '?') + parameter + '=' + value;
    }
};

var homepageCache = {};
$(document).ready(function() {
    $('.js-slider-switch').slick({
        arrows: false
    });

    $('.js-slider-switch').on('afterChange', function(event, slick, direction) {
        var index = slick.slickCurrentSlide();
        if (index !== 0) {
            $('.js-switch-container').removeClass('cc-selected');
            $('.js-switch-container').eq((index - 1) % 3).addClass('cc-selected');
        } else {
            $('.js-switch-container').removeClass('cc-selected');
        }
    });

    var genderAlreadyChoose = checkGenderHref(document.location.href);

    $('.js-switch-container').ready(function(e) {
        if (genderAlreadyChoose) {
            $('.js-gender-' + genderAlreadyChoose).click();
        }
        $('.js-switch-container').on('keydown', function(e) {
            var index = 0;
            if (e.keyCode === 39) {
                $('.js-slider-switch').slick('slickNext');
                index = $('.js-slider-switch').slick('slickCurrentSlide');
            }
            if (e.keyCode === 37) {
                $('.js-slider-switch').slick('slickPrev');
                index = $('.js-slider-switch').slick('slickCurrentSlide');
            }
            // handle spacebar button trigger click (need to prevent scrolling)
            if (e.keyCode === 32) {
                e.preventDefault();
                $(e.target).trigger('click');
            }
            if (index !== 0) {
                $('.js-switch-container a').eq((index - 1) % 3).focus();
            }
        });
    });

    $(document).on('click', '.js-switch-gender', function(e) {
        e.preventDefault();
        var link = $(e.currentTarget).attr('href');
        var gender = $(e.currentTarget).data('gtmhref');

        var navigateToImgNumber = $(e.currentTarget).data('rel-img') + 1;
        if (navigateToImgNumber <= $(this).closest('.cc-pd').find('.js-slider-switch').data('n-images')) {
            $(this).closest('.cc-pd').find('.js-slider-switch').slick('slickGoTo', navigateToImgNumber);
        }

        let updatePageId = function(link) {
            let tokens = link.split('.html')[0].split('/');
            let genderPageId = tokens[tokens.length -1];
            $('#mainContentContainer').attr('data-page-id', genderPageId);
        }

        $(this).closest('.cc-pd').find('.js-switch-container').removeClass('cc-selected');
        $('.cc-content-switcher .js-switch-container .js-switch-gender').attr('aria-selected', 'false');
        $(this).attr('aria-selected', 'true');
        $(e.currentTarget).closest('.js-switch-container').addClass('cc-selected');
        
        // Set focus on the first focussable element on the slick-active inside current slide active
        // var firstFocusable = $(this).closest('.cc-pd').find('.slick-current.slick-active').find('.cc-button.cc-button-tertiary').first();
        // // We need time to let the slide slick
        // setTimeout(() => {firstFocusable.focus();}, 500);
        
        var cloudinaryVideos = require('./cloudinaryVideos');
        if (homepageCache[link]) {
            $('#mainContentContainer').html(homepageCache[link]);
            cloudinaryVideos.restartInizializedVideo();
            updatePageId(link);
            history.replaceState(null, null, replaceOrAddQueryParam(document.location.href, 'gender', gender));
        } else {
            $.ajax({
                url: link
            }).then(function(rsp) {
                var response = $('<html />').html(rsp);
                var data = response.find('.gender-page-inner');
                $('#mainContentContainer').html(data);
                cloudinaryVideos.initCloudinaryVideos(e);
                updatePageId(link);
                $(document).trigger('experience:init-30-relatives', '#mainContentContainer');
                $('body').trigger('experience:changebackground');
                homepageCache[link] = data;
                history.replaceState(null, null, replaceOrAddQueryParam(document.location.href, 'gender', gender));
            });
        }
        if (e.originalEvent !== undefined) {
            // preventing duplicate page data when queryparams force page changes automatically
            $('body').trigger('analytics:pushpagechange', { pagesubCategory: $(this).data('gtmhref') });
        }
    });
});
